import React from 'react'
import { Heading, Text } from '../ui'

/** Card de seção da Conta do cliente (abas Grupo / Cliente / Saúde). */
export function SectionCard({
  title,
  children,
  className,
}: {
  title: string
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow px-3 py-2.5 h-full ${className ?? ''}`}>
      <Heading as="h3" size="lg" className="text-gray-900 dark:text-white mb-2">
        {title}
      </Heading>
      {children}
    </div>
  )
}

/** Campo label + valor (grade da aba Cliente). */
export function Field({
  label,
  value,
  className,
}: {
  label: string
  value: string
  className?: string
}) {
  return (
    <div className={`min-w-0 ${className ?? ''}`}>
      <dt className="text-xs leading-4 text-gray-500 dark:text-gray-400">{label}</dt>
      <dd className="text-sm leading-5 text-gray-900 dark:text-gray-100 break-words">{value}</dd>
    </div>
  )
}

/** Grade 2 colunas iguais — alinha as linhas entre os cards da esquerda. */
export function FieldsGrid({ children }: { children: React.ReactNode }) {
  return <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2.5">{children}</dl>
}

/** Placeholder quando o bloco ainda não tem dados. */
export function EmptyBlock({ message }: { message: string }) {
  return (
    <div className="flex min-h-[2.75rem] items-center justify-center rounded-md border border-dashed border-gray-200 dark:border-gray-600 px-2 py-2 text-center">
      <Text size="sm" color="muted">
        {message}
      </Text>
    </div>
  )
}

/** Campo empilhado com separador (sidebar da aba Grupo). */
export function FieldRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col gap-0.5 py-1.5 border-b border-gray-100 dark:border-gray-700/80 last:border-0">
      <Text size="xs" className="text-gray-500 dark:text-gray-400">
        {label}
      </Text>
      <Text size="sm" className="text-gray-900 dark:text-gray-100 break-words">
        {value}
      </Text>
    </div>
  )
}
